/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaLink2: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="link2" viewBox="0 0 24 24">
      <g clipPath="url(#clip0_1374_343)">
        <path
          d="M15 8C14.448 8 14 7.552 14 7C14 6.448 14.448 6 15 6H18C19.591 6 21.117 6.632 22.243 7.757C23.369 8.882 24 10.408 24 12C24 15.314 21.314 18 18 18H15C14.448 18 14 17.552 14 17C14 16.448 14.448 16 15 16H18C20.209 16 22 14.209 22 12C22 10.939 21.579 9.922 20.828 9.172C20.077 8.422 19.06 8 18 8H15ZM9 16C9.552 16 10 16.448 10 17C10 17.552 9.552 18 9 18H6C4.409 18 2.883 17.368 1.757 16.243C0.631 15.118 0 13.592 0 12C0 8.686 2.686 6 6 6H9C9.552 6 10 6.448 10 7C10 7.552 9.552 8 9 8H6C3.791 8 2 9.791 2 12C2 13.061 2.421 14.078 3.172 14.828C3.923 15.578 4.94 16 6 16H9ZM8 13C7.448 13 7 12.552 7 12C7 11.448 7.448 11 8 11H16C16.552 11 17 11.448 17 12C17 12.552 16.552 13 16 13H8Z"
          fill="currentColor"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1374_343"></clipPath>
      </defs>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaLink2)
